module.exports = __webpack_public_path__ + "static/img/optimize-ai-img.d71c0c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/career_panorama/optimize-ai-img.png
// module id = H/6h
// module chunks = 1